import { useState } from "react";
import { Calendar, Lightbulb, FileText, Video, Film, Package } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import { BookingDialog } from "./BookingDialogLazy";

const Process = () => {
  const processSteps = [
    { title: "Erstgespräch", description: "Wir hören zu, verstehen Ihre Ziele und entwickeln eine klare Vision." },
    { title: "Kreative Konzeption", description: "Wir gestalten eine visuelle Sprache, die Ihre Marke authentisch repräsentiert." },
    { title: "Produktionsplanung", description: "Von Moodboards bis Storyboards – wir bringen das Konzept in Form." },
    { title: "Produktion", description: "Wir drehen, inszenieren und produzieren mit cinematischer Qualität." },
    { title: "Postproduktion", description: "Jedes Detail wird verfeinert – Schnitt, Farbe, Sound und Emotion." },
    { title: "Übergabe & Beratung", description: "Sie erhalten Ihr Material in allen Formaten plus strategische Empfehlungen." }
  ];
  const icons = [Calendar, Lightbulb, FileText, Video, Film, Package];
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  
  const plugin = Autoplay({ delay: 3000, stopOnInteraction: true });

  return (
    <section className="section-padding bg-gradient-to-b from-background to-secondary/20">
      <div className="container-custom">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Von der Vision zur <span className="text-gradient">Wirklichkeit</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Jedes Projekt beginnt mit Verständnis. Wir produzieren nicht irgendwelche Bilder – wir entwickeln visuelle Strategien mit klarem Ziel. So wird aus Ihrer Idee echte Wirkung:
          </p>
        </div>

        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          plugins={[plugin]}
          className="w-full max-w-5xl mx-auto mb-12"
        >
          <CarouselContent>
            {processSteps.map((step, index) => {
              const Icon = icons[index] ?? icons[0]!;
              return (
                <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                  <div className="p-2">
                    <div 
                      className="group relative bg-card border border-border rounded-xl overflow-hidden hover:border-primary/50 transition-all duration-300 hover:shadow-[0_0_30px_hsl(var(--primary)/0.1)]"
                    >
                      <div className="flex items-center justify-center bg-gradient-to-br from-primary/10 to-secondary/20 p-6">
                        <Icon className="w-12 h-12 text-primary" />
                      </div>
                      <div className="p-4">
                        <div className="flex items-start justify-between gap-2 mb-2">
                          <h3 className="text-lg font-semibold">{step.title}</h3>
                          <span className="text-2xl font-bold text-primary/20">{index + 1}</span>
                        </div>
                        <p className="text-sm text-muted-foreground">{step.description}</p>
                      </div>
                    </div>
                  </div>
                </CarouselItem>
              );
            })}
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>

        <div className="text-center animate-fade-in">
          <p className="text-lg text-muted-foreground mb-6">
            Zusammenarbeit ist für uns zentral. Sie sind Teil des Prozesses – transparent, partnerschaftlich und individuell.
          </p>
          <button 
            className="border-primary/30 bg-primary/5 text-primary backdrop-blur-xs hover:bg-primary/10 px-8 py-4 text-lg rounded-full font-semibold transition-all border flex items-center justify-center gap-2 mx-auto"
            onClick={() => setIsBookingOpen(true)}
          >
            <Calendar className="w-5 h-5" />
            Projekt starten
          </button>
        </div>
      </div>
      
      <BookingDialog open={isBookingOpen} onOpenChange={setIsBookingOpen} />
    </section>
  );
};

export default Process;
